import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let SBProMenuPages = class SBProMenuPages extends Vue {
};
SBProMenuPages = __decorate([
    Component({})
], SBProMenuPages);
export default SBProMenuPages;
